module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_IN.a4a8b7d5.txt";